var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService, prepareParams, } from "./baseService";
class JobService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "job";
    }
    getEmployeeJobs(id, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.get(`/employee/${id}/${this.controllerName}`, { params });
            return data;
        });
    }
    getHazardJobs(id, options) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const params = prepareParams(options);
            if (options === null || options === void 0 ? void 0 : options.startDate) {
                params.startDate = options.startDate;
            }
            if (options === null || options === void 0 ? void 0 : options.endDate) {
                params.endDate = options.endDate;
            }
            const { data } = yield this.api.get(`/${this.controllerName}/${id}/hazards`, { params });
            return data;
        });
    }
    getJobLocation(id, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.get(`/${this.controllerName}/${id}/location`, { params });
            return data;
        });
    }
    getSummaryData(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = prepareParams(options);
            this.api.defaults.headers = this.getDefaultHeaders();
            if (options === null || options === void 0 ? void 0 : options.category) {
                params.category = options.category;
            }
            if (options === null || options === void 0 ? void 0 : options.startDate) {
                params.startDate = options.startDate;
            }
            if (options === null || options === void 0 ? void 0 : options.endDate) {
                params.endDate = options.endDate;
            }
            const { data } = yield this.api.get(`/${this.controllerName}/summary`, { params });
            return data;
        });
    }
    getTelematicsVehicle(jobId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.get(`${this.controllerName}/${jobId}/vehicle`);
            return data;
        });
    }
}
export const jobService = new JobService();
//# sourceMappingURL=JobService.js.map